<template>
  <div class="font-light text-common-grey">
    All {{ currentCategory }} {{ $t("components") }}
  </div>
  <div class="flex flex-wrap w-full">
    <div
      v-for="component in components"
      :key="component.slug"
      class="w-48 h-48 mb-4 mr-4 bg-gray-100 rounded-lg cursor-pointer hover:shadow-lg"
      @click="$emit('componentSelect', component.slug)">
      <div class="flex items-center mt-4 ml-2 space-x-2">
        <component
          :is="component.icon"
          :color_1="component.icon_color_1"
          :color_2="component.icon_color_2"
          class="w-6 h-6 mr-3 transition ease-in-out min-w-6 min-h-6 hover:text-dark-body-text text-common-grey duration-side-menu-transition-duration" />

        <span class="w-full max-h-12">{{ component.name }}</span>
      </div>

      <div class="overflow-hidden w-44 h-36">
        <img class="object-contain p-6 pr-2 rounded-md w-44" :src="imageSrc(component.slug)" :alt="$t('preview')">
      </div>
    </div>
  </div>
</template>

<script>
import PortfolioOverviewGroupIcon from "@/components/shared/icons/PortfolioOverviewGroupIcon.vue"
import Customer360GroupIcon from "@/components/shared/icons/Customer360GroupIcon.vue"

import InsightsGroupIcon from "@/components/shared/icons/InsightsGroupIcon.vue"
import RevenueGroupIcon from "@/components/shared/icons/RevenueGroupIcon.vue"
import ExpansionGroupIcon from "@/components/shared/icons/ExpansionGroupIcon.vue"
import LifecycleGroupIcon from "@/components/shared/icons/LifecycleGroupIcon.vue"
import ResourcesGroupIcon from "@/components/shared/icons/ResourcesGroupIcon.vue"
import AIComponentsIcon from "@/components/shared/icons/AIComponentsIcon.vue"

export default {
  components: {
    PortfolioOverviewGroupIcon,
    Customer360GroupIcon,
    InsightsGroupIcon,
    RevenueGroupIcon,
    ExpansionGroupIcon,
    LifecycleGroupIcon,
    ResourcesGroupIcon,
    AIComponentsIcon
  },
  props: { components: null, currentCategory: null },
  emits: ["componentSelect"],
  data() {
    return {}
  },
  computed: {
    imageSrc() {
      return (slug) => {
        const images = import.meta.glob("@/assets/*.webp", { eager: true })
        const imagePath = `/src/assets/${slug}-preview.webp`
        const image = Object.entries(images).find(([path]) => path.endsWith(imagePath))
        // Return the resolved image URL or a default/fallback image URL this case is null
        return image ? image[1].default : null
      }
    }
  }
}
</script>
